export class SubDepartmentModel{
    Department_Code: string = '';
    Department_Name : string = '';
    Sub_Dept_Code : string = '';
    Sub_Dept_Name : string = '';
    Manager_Email : string = '';
    Supervisor_Email : string = '';
    Department_Active : boolean = false;
    Active: boolean = false;
    Created_By : number = 0;
}